import { Typography, Stack } from "@mui/material";
import __ from "src/utils/Translations";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import DashboardTabs from "src/Pages/Company/Dashboard/components/Heading/DashboardTabs";

const Heading = () => {
  const companyId = useCompanyId();
  const companyName = useCompanyName();

  return (
    <Stack gap="1.5rem">
      <Stack gap="0.5rem">
        <Typography variant="h4">{__("Dashboard")}</Typography>
        <Typography>{`${__(
          "Firma"
        )} ${companyName} (ID: ${companyId})`}</Typography>
      </Stack>
      <DashboardTabs />
    </Stack>
  );
};

export default Heading;
